var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"flat-amount",class:{'text-success': _vm.colorPositive&&_vm.value>0, 'text-error':_vm.colorNegative&&_vm.value<0}},[_vm._v(_vm._s(_vm.rep))])
}
var staticRenderFns = []

export { render, staticRenderFns }